import React, {useEffect, useState} from 'react';
import block from 'bem-cn-lite';
import {AsideHeader} from '@gravity-ui/navigation';
import {Icon, Text, Tooltip} from '@gravity-ui/uikit';
import mainSideBarIcon from '@assets/mainSideBarIcon.svg';
import {
    createFooterItems,
    createMenuItems,
    createSubheaderItems
} from './sideBarItems/sideBarItems';
import {useNavigate, useLocation} from 'react-router-dom';
import {PermissionGate} from '@components/PermissionGate';
import {getActivatableProps} from '@hooks/keyboard';

import './MainSideBar.scss';

const b = block('main-side-bar');

export const MainSideBar = () => {
    const [isCompact, setIsCompact] = useState(false);
    const [currentItem, setCurrentItem] = useState<string | null>(null);
    const navigate = useNavigate();
    const location = useLocation();

    const menuItems = createMenuItems(navigate, currentItem, setCurrentItem);

    const subheaderItems = createSubheaderItems(navigate, currentItem, setCurrentItem);
    const footerItems = createFooterItems(navigate, currentItem, setCurrentItem);

    useEffect(() => {
        const pathToItemMap: Record<string, string> = {
            '/home': 'main-item',
            '/orders': 'orders-item',
            '/clients': 'clients-item',
            '/reports': 'reports-item',
            '/crosses': 'crosses-item',
            '/settings': 'settings-item',
            '/suggest': 'suggest-item'
        };
        setCurrentItem(pathToItemMap[location.pathname] || null);
    }, [location.pathname]);

    const handleCompactChange = () => {
        setIsCompact((prevState) => !prevState);
    };

    return (
        <div className={b()}>
            <AsideHeader
                compact={isCompact}
                headerDecoration
                onChangeCompact={handleCompactChange} // Свернуть/развернуть
                logo={{
                    text: () => (
                        <div
                            style={{cursor: 'default'}}
                            onClick={(e) => e.preventDefault()}
                        >
                            <Text variant="subheader-3">АВТОТРАНЗИТ</Text>
                        </div>
                    ),
                    iconSrc: mainSideBarIcon,
                    textSize: 17
                }}
                subheaderItems={subheaderItems}
                menuItems={menuItems}
                renderFooter={() => (
                    <div className={`${b('footer')} ${isCompact ? b('footer--compact') : ''}`}>
                        {footerItems.map((item) => (
                            <PermissionGate key={item.id} roles={item.roles}>
                                <Tooltip
                                    key={item.id}
                                    content={
                                        <Text className={b('tooltip-content')}>{item.title}</Text>
                                    }
                                    placement="right"
                                    contentClassName={b('tooltip')}
                                    className={b('tooltip-container')}
                                    openDelay={0}
                                    closeDelay={0}
                                    disabled={!isCompact}
                                >
                                    <div
                                        className={`${b('footer-item')} ${
                                            isCompact ? b('footer-item--compact') : ''
                                        } ${item.current ? b('footer-item--active') : ''}`}
                                        {...getActivatableProps(item.onItemClick)}
                                    >
                                        <Icon
                                            data={item.icon}
                                            size={item.iconSize}
                                            className={b('footer-icon')}
                                        />
                                        {!isCompact && <Text variant="body-1">{item.title}</Text>}
                                    </div>
                                </Tooltip>
                            </PermissionGate>
                        ))}
                    </div>
                )}
            />
        </div>
    );
};
